import React, {Fragment} from "react";
import "./Tablestyle.css";

class ChartTable extends React.Component {
  render() {
    let data = this.props.data;
    return (
      <Fragment>
        {data === 0 || 'undefined' ? null :
      <div className="content">
        <div className="value">
          <div>{data.sharpe}</div>
          <div>Sharpe Ratio</div>
        </div>
        <div className="value">
          <div>{data.sortino_ratio}</div>
          <div>Sortino Ratio</div>
        </div>
          <div className="value">
            <div>{data.alpha}</div>
            <div>Alpha</div>
          </div>
          <div className="value">
            <div>{data.beta}</div>
            <div>Beta</div>
          </div>
      </div>
      }
      </Fragment>
    );
  }
}

export default ChartTable;



// WEBPACK FOOTER //
// ./src/components/d3Components/linechart/chartTable.js